if (!customElements.get('explore-carousel-list')) {
  class ExploreCarouselList extends HTMLElement {
    constructor() {
      super();
      this.track = null;
      this.prevBtn = null;
      this.nextBtn = null;
    }

    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      if (!this.track) return;

      const parent = this.closest('.explore-carousel') || document;
      this.prevBtn = parent.querySelector('[data-carousel-prev]');
      this.nextBtn = parent.querySelector('[data-carousel-next]');

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollByPage(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollByPage(1));

      this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
      window.addEventListener('resize', () => this.updateButtons(), { passive: true });

      // Initial state — wait one frame so layout is final
      requestAnimationFrame(() => this.updateButtons());
    }

    scrollByPage(direction) {
      const firstItem = this.track.querySelector('.explore-carousel__item');
      if (!firstItem) return;
      const itemRect = firstItem.getBoundingClientRect();
      const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 16;
      const visibleCount = Math.max(1, Math.floor(this.track.clientWidth / (itemRect.width + gap)));
      const step = (itemRect.width + gap) * visibleCount;
      this.track.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    updateButtons() {
      if (!this.prevBtn || !this.nextBtn) return;
      const atStart = this.track.scrollLeft <= 2;
      const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      this.prevBtn.toggleAttribute('disabled', atStart);
      this.nextBtn.toggleAttribute('disabled', atEnd);
    }
  }

  customElements.define('explore-carousel-list', ExploreCarouselList);
}
